



function checkboxButton() {


    var mainSelector           = ".checkbox-t";
    var inputSelector          = ".checkbox-t .inputs-t";
    var activeClass            = "selected-t";

    var checkbox_activer = function(elem){
        var checkboxLabel = $(elem).parents(mainSelector);
        checkboxLabel.toggleClass(activeClass);
    }


    $(document).on('click', inputSelector , function() {
        var timer;
        var this_ele = this;
        timer = setTimeout(function () {
            checkbox_activer(this_ele);
        });
    });


    $(inputSelector).each(function(index, el) {
        // $(inputSelector).each(function(index, el) {

        if ( $(this).parents(mainSelector).hasClass(activeClass) ){
            $(this).prop('checked', true).trigger("change");
        }
    });
};





export {checkboxButton}
